"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flightStatusText = flightStatusText;
const STATUS_HU = {
    ON_TIME: 'Időben',
    DELAYED: 'Késik',
    CANCELLED: 'Törölve',
    BOARDING: 'Beszállás',
    DEPARTED: 'Elindult',
    LANDED: 'Leszállt',
    DIVERTED: 'Eltérítve',
};
function flightStatusText(status, delayMinutes, localTimeText) {
    if (status === 'DELAYED' && delayMinutes > 0) {
        return `Késik (+${String(delayMinutes)} perc)`;
    }
    const base = STATUS_HU[status];
    if ((status === 'DEPARTED' || status === 'LANDED') && localTimeText !== undefined) {
        return `${base} ${localTimeText}`;
    }
    return base;
}
//# sourceMappingURL=flightStatusText.js.map